/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 01:27 pm
 * Last Modified: Saturday, 24-09-14 05:38 pm, by Roger
 */

import {
  Box,
  Link,
  List,
  listItemClasses,
  listItemTextClasses,
  stackClasses,
  styled,
  svgIconClasses,
  Typography,
  typographyClasses,
} from '@mui/material';

export const QrcodeText = styled(Typography)(() => ({
  color: '#B5B5B5',
  fontSize: '12px',
  fontWeight: 500,
  width: '100px',
  textAlign: 'center',
}));

export const LabelText = styled(Typography)(({ theme }) => ({
  color: '#FFF',
  fontSize: '14px',
  fontWeight: 500,
  [theme.breakpoints.only('xs')]: {
    fontSize: '12px',
  },
}));

export const SitemapLink = styled(Link)(() => ({
  display: 'block',
  color: '#D9D9D9',
  fontSize: '14px',
  fontWeight: 400,
  cursor: 'pointer',
}));

export const SitemapTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '18px',
  fontWeight: 700,
}));

export const SocialIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '12px',
  [theme.breakpoints.only('xs')]: {
    gap: '10px',
  },
  [`& .${svgIconClasses.root}`]: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    [theme.breakpoints.only('xs')]: {
      width: '20px',
      height: '20px',
    },
  },
}));

export const AboutUsBox = styled(Box)(({ theme }) => ({
  [`& .${typographyClasses.h5}`]: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '120%',
    color: theme.palette.common.white,
    [theme.breakpoints.only('xs')]: {
      fontSize: '12px',
      lineHeight: 'normal',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '12px',
      lineHeight: 'normal',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '14px',
      lineHeight: '120%',
    },
  },

  [`& .${typographyClasses.body1}`]: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#848E9C',
    textAlign: 'justify',
    [theme.breakpoints.only('xs')]: {
      fontSize: '12px',
      lineHeight: '16px',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '12px',
      lineHeight: '16px',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
}));

export const BottomTextBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '0 0 16px',
  [`& .${stackClasses.root}`]: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
    [theme.breakpoints.only('xs')]: {
      width: 'auto',
      flexDirection: 'column',
    },
  },
  [`& .${typographyClasses.root}`]: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '120%',
    color: '#848E9C',
    [theme.breakpoints.only('xs')]: {
      lineHeight: 'normal',
    },
  },
  [theme.breakpoints.only('xs')]: {
    padding: '0 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export const BoldWhiteText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: '120%',
  [theme.breakpoints.only('xs')]: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '120%',
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: 'inherit',
}));

export const SiteMapList = styled(List)(({ theme }) => ({
  [`& .${listItemClasses.root}:nth-of-type(even)`]: {
    backgroundColor: '#252837', // '#252837',
  },
  [`& .${listItemClasses.root}`]: {
    padding: '12px 16px',
    [`& .${listItemTextClasses.primary}`]: {
      color: theme.palette.common.white,
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '120%',
      [theme.breakpoints.only('xs')]: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '20px',
      },
    },
  },
}));
